import { useTranslation } from "react-i18next"
import { ActionDrawer } from "../ActionDrawer"
import { Box, Button } from "@mui/material"
import EvidenceDetail from "../../pages/actionPlans/pages/form/components/evidenceDetail"
import { UploadEvidence } from "../uploadEvidence"
import { useStyles } from "./styles"
import { EvidenceDetailProps } from "../../pages/actionPlans/pages/form/components/evidenceDetail/type"
import { UploadEvidenceProps } from "../uploadEvidence/types"
import React from "react"
import { Payload } from "../ActionDrawer/types"
import { ViewEvidence } from "./enum"
import { FooterSimple } from "../buttons/footer"

export const DetailAndUploadOfEvidences = ({ detail, upload, Node, view = ViewEvidence.DETAIL, save, downloadEvidences, disable }: { view: ViewEvidence; disable?: boolean; downloadEvidences?: () => Promise<void>; save: () => void; detail: EvidenceDetailProps; upload: UploadEvidenceProps, Node: React.FC<{ payload: Payload }> }) => {
    const styles = useStyles()
    const { t } = useTranslation()
    return (
        <ActionDrawer
            title={view == ViewEvidence.DETAIL ? t('actionPlan.evidenceList') : t('loogbook.titles.chargeEvidence')}
            body={
                <Box sx={styles.evidence} >
                    {view == ViewEvidence.DETAIL && <>
                        <Box sx={styles.mainContainer}>
                            <Box sx={styles.bodyContainer}>
                                <EvidenceDetail {...detail} />
                            </Box>
                            <Box>
                                <Button variant='text_primary_small' onClick={downloadEvidences} disabled={disable}>{t('schedule.buttons.downloadEvidence')}</Button>
                            </Box>
                        </Box>
                    </>
                    }
                    {view == ViewEvidence.EDIT && (
                        <>
                            <UploadEvidence {...upload} />

                            <FooterSimple
                                confirm={{
                                    children: t('general.save'),
                                    onClick: save
                                }}
                                cancel={{
                                    disabled: true
                                }}
                            />
                        </>
                    )}

                </Box>
            }
        >
            {(payload) => <Node payload={payload} />}
        </ActionDrawer>
    )
}